export const LK_OILGASFORUM_HOST = 'lk.oilgasforum.ru';
export const UTM_PARAMS_STORAGE_KEY = 'utmParams';
export const ORIGINAL_LK_HREF_ATTR = 'data-original-lk-href';

export function isLkOilgasforumUrl(url: string): boolean {
    try {
        const parsed = new URL(url, typeof window !== 'undefined' ? window.location.origin : 'https://oilgasforum.ru');
        return parsed.hostname === LK_OILGASFORUM_HOST;
    } catch {
        return false;
    }
}

export function hasUtmParams(url: string): boolean {
    try {
        const parsed = new URL(url, typeof window !== 'undefined' ? window.location.origin : 'https://oilgasforum.ru');
        for (const key of parsed.searchParams.keys()) {
            if (key.startsWith('utm_')) {
                return true;
            }
        }
        return false;
    } catch {
        return false;
    }
}

export function getUtmParamsFromStorage(): Record<string, string> {
    if (typeof window === 'undefined') {
        return {};
    }

    try {
        const stored = localStorage.getItem(UTM_PARAMS_STORAGE_KEY);
        if (!stored) {
            return {};
        }

        const parsed: unknown = JSON.parse(stored);
        if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
            return {};
        }

        const result: Record<string, string> = {};

        for (const [key, value] of Object.entries(parsed)) {
            if (typeof value === 'string' && value) {
                result[key] = value;
            } else if (Array.isArray(value) && typeof value[0] === 'string' && value[0]) {
                result[key] = value[0];
            }
        }

        return result;
    } catch {
        return {};
    }
}

export function appendUtmParamsToLkUrl(url: string, utmParams: Record<string, string>): string {
    if (!isLkOilgasforumUrl(url) || Object.keys(utmParams).length === 0) {
        return url;
    }

    try {
        const parsed = new URL(url, typeof window !== 'undefined' ? window.location.origin : 'https://oilgasforum.ru');

        for (const [key, value] of Object.entries(utmParams)) {
            if (!parsed.searchParams.has(key)) {
                parsed.searchParams.set(key, value);
            }
        }

        return parsed.toString();
    } catch {
        return url;
    }
}
